import React from "react";
import "./SearchPage.scss";
import Icon from "../Icon";
import Spinner from "../Spinner";

export default function SearchPage({ style, placeholder, value, onChange }) {
  return (
    <div className="c-search-page">
      <input style={style} placeholder={placeholder ? placeholder : ""} value={value} type="text" onChange={onChange} />
      <Icon icon="search" />
    </div>
  );
}
